export class UnsplashApiFailureException extends Error {
  constructor(message) {
    super(message);
  }
}